module.exports = __webpack_public_path__ + "images/liinilaevad/payment/seb.png";